module.exports = __webpack_public_path__ + "static/media/remove.a402abf9.png";